import React, { useEffect, useState } from 'react';

// Material Resources
import {
  Input,
  IconButton,
  Tooltip,
  Typography,
  TableCell,
  Checkbox,
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  InputAdornment,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import RefreshIcon from '@material-ui/icons/Refresh';
import TodayIcon from '@material-ui/icons/Today';
import EditIcon from '@material-ui/icons/Edit';
import AssignmentReturnedIcon from '@material-ui/icons/AssignmentReturned';
import PageviewOutlinedIcon from '@material-ui/icons/PageviewOutlined';
import DescriptionIcon from '@material-ui/icons/Description';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import Link from '@material-ui/core/Link';
import Snackbar from '@material-ui/core/Snackbar';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

// GraphQl
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';

// Components & Others
import MUIDataTable from 'mui-datatables';
import PropTypes from 'prop-types';
import moment from 'moment';
import NumberFormat from 'react-number-format';
import CustomOptions from '../../../../CustomOptions';
import LoadingIndicator from '../../../../LoadingIndicator';
import { useSnackbar } from 'notistack';
import {
  getOptions,
  generateColumn,
  successMessage,
  errorMessage,
  edgeToList,
  decimalAdjust,
  downloadBase64Document,
} from '../../../../../utils/commonFunctions';
import { textLabels } from 'src/translations/components/MUIDataTable';
import {
  LIST_PARTICIPANT_RAISING_ALL,
  GENERATE_CONTRACT,
  GENERATE_BLANK_CONTRACT,
  EDIT_CONTRACT,
  APPROVE_CONTRACT,
  UPLOAD_CONTRACT,
  UPDATE_SIGNATURE,
  GET_REPORT_EXCEL,
} from './queries';
import { LIST_PROMOTERS } from 'src/components/Models/Users/queries';
import { LIST_FUNDS } from '../../queries';
import CustomModal from 'src/components/CustomModal';
import PDFViewerModal from '../../../../PDFViewerModal';
import { REACT_APP_SERVER_LINK } from 'src/utils/constants';

// Styles & Images
import useStyles from '../../styles';

function RaisingsParticipants(props) {
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [participationList, setParticipationList] = useState([]);
  const [currencySymbol, setCurrencySymbol] = useState('');
  const [clientID, setClientID] = useState(null);
  const [participationID, setParticipationID] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [url, setUrl] = useState('');
  const [fileName, setFileName] = useState('');
  const [file, setFile] = useState('');
  const [uploadedDate, setUploadedDate] = useState('');
  const [pageInfo, setPageInfo] = useState('');
  const [totalCount, setTotalCount] = useState('');
  const [listLength, setListLength] = useState(0);
  const [pageLength, setPageLength] = useState(10);

  //MODAL
  const [isMarried, setIsMarried] = useState(false);
  const [spouse, setSpouse] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [spouseEmail, setSpouseEmail] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSpouseSnackbar, setOpenSpouseSnackbar] = useState(false);
  const [openUploadModal, setOpenUploadModal] = useState(false);
  const [openContractModal, setOpenContractModal] = useState(false);
  const [campos, setCampos] = useState({});
  const [currentName, setCurrentName] = useState('');
  const [documentNumber, setDocumentNumber] = useState('');
  const [detail, setDetail] = useState('');
  const [distrito, setDistrito] = useState('');
  const [provincia, setProvincia] = useState('');
  const [departamento, setDepartamento] = useState('');
  const [pais, setPais] = useState('');
  const [remuneraciones, setRemuneraciones] = useState(false);
  const [ahorro, setAhorro] = useState(false);
  const [utilidades, setUtilidades] = useState(false);
  const [alquileres, setAlquileres] = useState(false);
  const [ventaAcciones, setVentaAcciones] = useState(false);
  const [ventaBienesInmuebles, setVentaBienesInmuebles] = useState(false);
  const [ventaBienesMuebles, setVentaBienesMuebles] = useState(false);
  const [herencias, setHerencias] = useState(false);
  const [prestamos, setPrestamos] = useState(false);
  const [autorizo, setAutorizo] = useState(false);
  const [otros, setOtros] = useState(false);
  const [otrosTexto, setOtrosTexto] = useState('');
  const [explicacion, setExplicacion] = useState('');

  //FILTERS
  const [filterPromoter, setFilterPromoter] = useState('');
  const [filterFund, setFilterFund] = useState('');
  const [filterState, setFilterState] = useState('');
  const [fromDate, setFromDate] = useState(moment('2026-01-01'));
  const [toDate, setToDate] = useState(moment());
  const [appliedFromDate, setAppliedFromDate] = useState(null);
  const [appliedToDate, setAppliedToDate] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [searchTextInput, setSearchTextInput] = useState('');

  const { data: promotersData } = useQuery(LIST_PROMOTERS);
  const { data: fundsData } = useQuery(LIST_FUNDS);
  const allowedFundsIds = [
    'RnVuZFR5cGU6MTk=',
    'RnVuZFR5cGU6Mjk=',
    'RnVuZFR5cGU6Mjg=',
    'RnVuZFR5cGU6MzM=',
    'RnVuZFR5cGU6MzU=',
  ];

  const dateFormat = 'YYYY-MM-DD';

  const CONTRACT_STATE_KEYS = {
    GENERATED: 'GENERATED',
    EDIT_PENDING: 'EDIT_PENDING',
    APPROVED: 'APPROVED',
    SIGNED: 'SIGNED',
    UPLOADED: 'UPLOADED',
    PENDING: 'PENDING',
  };

  const getStateInfo = p => {
    if (p.contractGenerated)
      return {
        key: CONTRACT_STATE_KEYS.GENERATED,
        label: 'Generado (Enviado a firma)',
      };

    if (p.contractEdited)
      return {
        key: CONTRACT_STATE_KEYS.EDIT_PENDING,
        label: 'Pendiente de Aprobar y Enviar',
      };

    if (p.contractApproved)
      return {
        key: CONTRACT_STATE_KEYS.APPROVED,
        label: 'Aprobado/Enviado',
      };

    if (p.contractSigned)
      return {
        key: CONTRACT_STATE_KEYS.SIGNED,
        label: 'Firmado',
      };

    if (p.contractUploaded)
      return {
        key: CONTRACT_STATE_KEYS.UPLOADED,
        label: 'Subido',
      };

    return {
      key: CONTRACT_STATE_KEYS.PENDING,
      label: 'Pendiente de Editar/Generar',
    };
  };

  const atLeastOneChecked = () => {
    return [
      remuneraciones,
      ahorro,
      utilidades,
      alquileres,
      ventaAcciones,
      ventaBienesInmuebles,
      ventaBienesMuebles,
      herencias,
      prestamos,
      otros,
    ].some(value => value === true);
  };

  const toBase64 = file =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);
    });

  const handleChange = async e => {
    try {
      let name = e.target.files[0].name;
      const encoded = await toBase64(e.target.files[0]);
      setFileName(name);
      setFile(encoded);
    } catch (error) {
      console.log('error', error);
    }
  };

  const {
    loading: listLoading,
    error: listError,
    data: listData,
    fetchMore,
    refetch,
  } = useQuery(LIST_PARTICIPANT_RAISING_ALL, {
    variables: {
      search: searchText ? searchText : null,
      fundId: filterFund || null,
      promoterId: filterPromoter || null,
      state: filterState || null,
      fromDate: appliedFromDate || null,
      toDate: appliedToDate || null,
      first: 10,
      afterCursor: null,
      last: null,
      beforeCursor: null,
    },
  });

  if (listError) {
    console.error('ERROR', listError);
  }

  function getParticipants(listContracts) {
    if (listContracts) {
      const participationListTmp = listContracts.map(participation => {
        const {
          lastParticipation,
          createdDate,
          numFee,
          amount,
          realAmount,
          realNumFee,
          client,
          raising,
          classFund,
          validated,
          isApproved,
          participationType,
          isRopSync,
          keynuaSignedAt,
          contractUploadedDate,
        } = participation;
        setCurrencySymbol(raising.fund.currency.symbol);
        const newParticipation = {
          options: {
            id: lastParticipation.id,
            name:
              client.user.firstName +
              ' ' +
              client.user.lastName +
              ' ' +
              client.user.maternalSurname,
            isPN:
              client.user?.userType == 'PN' || client.user?.userType == 'UU'
                ? true
                : false,
            isMarried: client.propertyRegime?.society || false,
            autorizo: client.dataProcessingAuthorization || false,
            detail: client.address?.detail,
            country: client.address?.country?.name,
            county: client.address?.county?.name,
            city: client.address?.city?.name,
            district: client.address?.district?.name,
            documentNumber: client.user.documentNumber,
            fundAcronym: raising.fund.acronym,
            raisingAcronym: raising.acronym,
            classFund: classFund ? classFund.name : '',
            contractType:
              client.propertyRegime?.society &&
              client.maritalStatus.spouse &&
              participationType != 'CP'
                ? 'SG'
                : participationType == 'CP'
                ? 'COOP'
                : client.user?.userType == 'PJ'
                ? 'PJ'
                : 'PN',
            state: lastParticipation.state,
            validated:
              client.user.isVinculated && isApproved
                ? 'Si'
                : !client.user.isVinculated
                ? '-'
                : 'No',
            participationType: participationType,
            participantID: client.id,
            contractGenerated: lastParticipation.contractGenerated,
            contractEdited: lastParticipation.contractEdited,
            contractClientEdited: lastParticipation.contractClientEdited,
            contractApproved: lastParticipation.contractApproved,
            contractSigned: lastParticipation.contractSigned,
            contractUploaded: lastParticipation.contractUploaded,
            isSync: isRopSync ? true : false,
            signDate: keynuaSignedAt
              ? keynuaSignedAt
              : contractUploadedDate
              ? contractUploadedDate
              : '',
            createdDate: createdDate,
          },
          order: lastParticipation.order,
          clientID: client.id,
          promoter: client.coreConsultant
            ? client.coreConsultant.user.firstName +
              ' ' +
              client.coreConsultant.user.lastName
            : client.promoter
            ? client.promoter.user.firstName +
              ' ' +
              client.promoter.user.lastName
            : '',
          promoterId: client.coreConsultant
            ? client.coreConsultant.id
            : client.promoter
            ? client.promoter.id
            : '',
          state: getStateInfo(lastParticipation).label,
          stateKey: getStateInfo(lastParticipation).key,
          dateEntry: moment(createdDate).format('YYYY-MM-DD HH:mm:ss'),
          signDate: keynuaSignedAt
            ? keynuaSignedAt
            : contractUploadedDate
            ? contractUploadedDate
            : '',
          quotes: numFee,
          validated:
            client.user.isVinculated && isApproved
              ? 'Si'
              : !client.user.isVinculated
              ? '-'
              : 'No',
          participationType: participationType,
          fundId: raising && raising.fund ? raising.fund.id : '',
          fundAcronym:
            raising && raising.fund && raising.fund.businessName
              ? raising.fund.businessName
              : '',
          raisingAcronym: raising && raising.acronym ? raising.acronym : '',
          classFund: classFund ? classFund.name : '',
          amount: decimalAdjust('ceil', amount, -2),
          realAmount: decimalAdjust('ceil', realAmount, -2),
          realNumFee: realNumFee ?? 0,
          participants:
            client.user.firstName +
            ' ' +
            client.user.lastName +
            ' ' +
            client.user.maternalSurname,
          percentajes: lastParticipation.participationPercentage + '%',
        };
        return newParticipation;
      });
      setParticipationList(participationListTmp);
    }
  }

  useEffect(() => {
    if (listData) {
      setTotalCount(listData?.listParticipantRaisingAll.totalCount);
      setPageInfo(listData?.listParticipantRaisingAll.pageInfo);
      let listTmp = edgeToList(listData, 'listParticipantRaisingAll');
      setListLength(listTmp.length);
      getParticipants(listTmp);
    }
  }, [listData]);

  const [generateContract, { loading: loadingGenerateContract }] = useMutation(
    GENERATE_CONTRACT,
    {
      onCompleted(data) {
        if (data?.generateParticipantContract?.created) {
          refetchList();
          successMessage('Contrato generado con éxito', enqueueSnackbar);
        } else {
          errorMessage(
            'El cliente aún no firmó su ficha cliente ó caducó la fecha de la misma',
            enqueueSnackbar,
          );
        }
      },
      onError(error) {
        errorMessage(error, enqueueSnackbar);
      },
    },
  );

  const [
    generateBlankContract,
    { loading: loadingGenerateBlankContract },
  ] = useMutation(GENERATE_BLANK_CONTRACT, {
    onCompleted(data) {
      if (data?.generateParticipantBlankContract?.created) {
        setUrl(data?.generateParticipantBlankContract?.url);
        successMessage('Contrato generado con éxito', enqueueSnackbar);
        setShowModal(true);
      } else {
        errorMessage(
          'Error al generar contrato, intente nuevamente',
          enqueueSnackbar,
        );
      }
    },
    onError(error) {
      errorMessage(error, enqueueSnackbar);
    },
  });

  const [editContract, { loading: loadingEditContract }] = useMutation(
    EDIT_CONTRACT,
    {
      onCompleted(data) {
        if (
          data?.editParticipantContract?.created &&
          data.editParticipantContract.signingDocument
        ) {
          setOpenContractModal(false);
          updateSigningDocument({
            variables: {
              id: data.editParticipantContract.signingDocument.id,
              input: campos,
            },
          });
        } else {
          setOpenContractModal(false);
          errorMessage(
            'El cliente aún no firmó su ficha cliente ó caducó la fecha de la misma, ó ocurrió un error, intente nuevamente',
            enqueueSnackbar,
          );
        }
      },
      onError(error) {
        errorMessage(error, enqueueSnackbar);
      },
    },
  );

  const [approveContract, { loading: loadingApproveContract }] = useMutation(
    APPROVE_CONTRACT,
    {
      onCompleted(data) {
        if (data?.approveParticipantContract?.created) {
          refetchList();
          successMessage(
            'Contrato aprobado y enviado con éxito',
            enqueueSnackbar,
          );
        } else {
          errorMessage(
            'Hubo un error en el envío de correo, intente nuevamente',
            enqueueSnackbar,
          );
        }
      },
      onError(error) {
        errorMessage(error, enqueueSnackbar);
      },
    },
  );

  const [uploadContract, { loading: loadingUploadContract }] = useMutation(
    UPLOAD_CONTRACT,
    {
      onCompleted(data) {
        if (data?.uploadParticipantContract?.created) {
          refetchList();
          successMessage('Contrato cargado con éxito', enqueueSnackbar);
        } else {
          errorMessage(
            'Hubo un error en el proceso de carga, intente nuevamente',
            enqueueSnackbar,
          );
        }
      },
      onError(error) {
        errorMessage(error, enqueueSnackbar);
      },
    },
  );

  const updateMutation = useMutation(
    UPDATE_SIGNATURE,
    {
      onCompleted(data) {
        if (data.updateSignature?.keynuaProcess) {
          refetchList();
          successMessage('Contrato editado con éxito', enqueueSnackbar);
        } else {
          errorMessage(
            'Hubo un error al crear el proceso de Keynua, intente nuevamente',
            enqueueSnackbar,
          );
        }
      },
    },
    getOptions({
      mutationName: 'updateSignature',
      modelName: 'signingProcess',
      enqueueSnackbar,
      completeCallback: () => ({}),
    }),
  );

  const [updateSigningDocument, { loading: updateLoading }] = updateMutation;

  const getListRefetchVariables = ({
    search = searchText,
    fundId = filterFund,
    promoterId = filterPromoter,
    state = filterState,
    fromDate = appliedFromDate,
    toDate = appliedToDate,
    first = 10,
    afterCursor = null,
    last = null,
    beforeCursor = null,
  } = {}) => ({
    search: search ? search : null,
    fundId: fundId || null,
    promoterId: promoterId || null,
    state: state || null,
    fromDate: fromDate || null,
    toDate: toDate || null,
    first,
    afterCursor,
    last,
    beforeCursor,
  });

  const refetchList = overrides => refetch(getListRefetchVariables(overrides));

  const runSearch = searchValue => {
    setPageLength(10);
    setSearchText(searchValue);
    refetchList({
      search: searchValue,
      first: 10,
      afterCursor: null,
      last: null,
      beforeCursor: null,
    });
  };

  const handleSearchSubmit = e => {
    e.preventDefault();
    e.stopPropagation();
    runSearch(searchTextInput);
  };

  const handleSearchClear = e => {
    e.preventDefault();
    e.stopPropagation();
    setSearchTextInput('');
    runSearch('');
  };

  const columns = [
    generateColumn('Fondo', 'fundAcronym'),
    generateColumn('Levantamiento', 'raisingAcronym'),
    generateColumn('Clase', 'classFund'),
    generateColumn('Promotor', 'promoter'),
    generateColumn('Participante', 'participants'),
    generateColumn('Cuotas Cognito', 'quotes', {
      setCellProps: () => ({
        style: {
          width: '100px',
          maxWidth: '100px',
          whiteSpace: 'nowrap',
        },
      }),
    }),
    generateColumn('Monto Cognito', 'amount', {
      setCellProps: () => ({
        style: {
          width: '120px',
          maxWidth: '120px',
          whiteSpace: 'nowrap',
        },
      }),
      customBodyRender: amount => (
        <>
          {`${currencySymbol} `}
          <NumberFormat
            displayType="text"
            fixedDecimalScale
            decimalScale={2}
            thousandSeparator
            value={amount}
          />
        </>
      ),
    }),
    generateColumn('Cuotas Cierre', 'realNumFee', {
      setCellProps: () => ({
        style: {
          width: '100px',
          maxWidth: '100px',
          whiteSpace: 'nowrap',
        },
      }),
    }),
    generateColumn('Monto Cierre', 'realAmount', {
      setCellProps: () => ({
        style: {
          width: '120px',
          maxWidth: '120px',
          whiteSpace: 'nowrap',
        },
      }),
      customBodyRender: amount => (
        <>
          {`${currencySymbol} `}
          <NumberFormat
            displayType="text"
            fixedDecimalScale
            decimalScale={2}
            thousandSeparator
            value={amount}
          />
        </>
      ),
    }),
    generateColumn('Fecha Creación', 'dateEntry'),
    generateColumn('Fecha Firma', 'signDate'),
    generateColumn('Porcentaje', 'percentajes'),
    generateColumn('Validación Vinculado', 'validated'),
    generateColumn('Estado', 'state'),
    generateColumn('Opciones', 'options', {
      customBodyRender: (value, tableMeta) => {
        const {
          id,
          state,
          name,
          isPN,
          isMarried,
          autorizo,
          documentNumber,
          detail,
          country,
          county,
          city,
          district,
          fundAcronym,
          raisingAcronym,
          classFund,
          contractType,
          validated,
          participationType,
          participantID,
          contractGenerated,
          contractEdited,
          contractClientEdited,
          contractApproved,
          contractSigned,
          contractUploaded,
          isSync,
          signDate,
          createdDate,
        } = value;
        let canSee = true;
        if (
          !contractApproved &&
          !contractGenerated &&
          !contractSigned &&
          !contractUploaded
        )
          canSee = false;
        let folder = 'contratos';
        if (contractGenerated && !contractClientEdited)
          folder = 'pdf-signing-documents';
        let options = ['ocustom'];

        let downloadUrl = `${REACT_APP_SERVER_LINK}/media/${folder}/contrato-${fundAcronym}-${raisingAcronym}-${documentNumber}.pdf`;
        if (
          signDate > '2026-04-14' ||
          createdDate > '2026-04-14' ||
          contractEdited
        ) {
          downloadUrl = `${REACT_APP_SERVER_LINK}/media/${folder}/${fundAcronym}-${contractType}-${classFund}-${`L${parseInt(
            raisingAcronym.slice(1),
            10,
          )
            .toString()
            .padStart(2, '0')}`}-${name}.pdf`;
        }
        return (
          <CustomOptions
            id={id}
            model="Participante"
            options={options}
            fullWidth
            customOption={
              <>
                <Tooltip arrow title="Editar" placement="top">
                  <IconButton
                    variant="contained"
                    color="secondary"
                    size="small"
                    className={classes.optionButtons}
                    disabled={
                      !isPN ||
                      !isSync ||
                      updateLoading ||
                      loadingEditContract ||
                      loadingApproveContract ||
                      loadingGenerateContract ||
                      loadingUploadContract ||
                      contractEdited ||
                      contractGenerated ||
                      contractApproved ||
                      contractSigned ||
                      contractUploaded ||
                      validated == 'No' ||
                      participationType == 'CP'
                    }
                    onClick={() => {
                      setIsMarried(isMarried);
                      setCurrentName(name);
                      setDocumentNumber(documentNumber);
                      setAutorizo(autorizo);
                      setDetail(detail);
                      setDistrito(district);
                      setProvincia(city);
                      setDepartamento(county);
                      setPais(country);
                      setParticipationID(id);
                      setOpenContractModal(true);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow title="Aprobar y Enviar" placement="top">
                  <IconButton
                    variant="contained"
                    color="secondary"
                    size="small"
                    className={classes.optionButtons}
                    disabled={
                      !isPN ||
                      !isSync ||
                      updateLoading ||
                      loadingEditContract ||
                      loadingApproveContract ||
                      loadingGenerateContract ||
                      loadingUploadContract ||
                      !contractEdited ||
                      contractGenerated ||
                      contractApproved ||
                      contractSigned ||
                      contractUploaded ||
                      validated == 'No' ||
                      participationType == 'CP'
                    }
                    onClick={() => {
                      approveContract({ variables: { id } });
                    }}
                  >
                    <CheckOutlinedIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip arrow title="Generar y Enviar" placement="top">
                  <IconButton
                    variant="contained"
                    color="secondary"
                    size="small"
                    className={classes.optionButtons}
                    disabled={
                      !isPN ||
                      !isSync ||
                      updateLoading ||
                      loadingEditContract ||
                      loadingApproveContract ||
                      loadingGenerateContract ||
                      loadingUploadContract ||
                      contractEdited ||
                      contractApproved ||
                      contractGenerated ||
                      contractSigned ||
                      contractUploaded ||
                      validated == 'No' ||
                      participationType == 'CP'
                    }
                    onClick={() => {
                      generateContract({ variables: { id } });
                    }}
                  >
                    <DescriptionIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Subir" placement="top" arrow>
                  <IconButton
                    variant="contained"
                    color="secondary"
                    size="small"
                    className={classes.optionButtons}
                    disabled={
                      // !isPN ||
                      updateLoading ||
                      loadingEditContract ||
                      loadingApproveContract ||
                      loadingGenerateContract ||
                      loadingUploadContract ||
                      // contractEdited ||
                      // contractApproved ||
                      // contractGenerated ||
                      contractSigned ||
                      contractUploaded ||
                      validated == 'No'
                      // participationType == 'CP'
                    }
                    onClick={() => {
                      setClientID(id);
                      setOpenUploadModal(true);
                    }}
                  >
                    <CloudUploadIcon className={classes.optionIcon} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Visualizar" placement="top" arrow>
                  <IconButton
                    variant="contained"
                    color="secondary"
                    size="small"
                    disabled={
                      !canSee || !isSync || validated == 'No'
                      // participationType == 'CP'
                    }
                    onClick={$ev => {
                      $ev.stopPropagation();
                      setShowModal(true);
                      setUrl(downloadUrl);
                    }}
                    className={classes.optionButtons}
                  >
                    <PageviewOutlinedIcon className={classes.optionIcon} />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Descargar" placement="top" arrow>
                  <Link
                    href={downloadUrl}
                    target="_blank"
                    disabled={
                      !canSee || !isSync || validated == 'No'
                      // participationType == 'CP'
                    }
                  >
                    <IconButton
                      variant="contained"
                      color="secondary"
                      size="small"
                      className={classes.optionButtons}
                      disabled={
                        !canSee || !isSync || validated == 'No'
                        // participationType == 'CP'
                      }
                    >
                      <CloudDownloadIcon className={classes.optionIcon} />
                    </IconButton>
                  </Link>
                </Tooltip>
                <Tooltip title="Contrato en blanco" placement="top" arrow>
                  <IconButton
                    variant="contained"
                    color="secondary"
                    size="small"
                    disabled={
                      !isPN ||
                      // !isSync ||
                      // validated == 'No' ||
                      participationType == 'CP'
                    }
                    className={classes.optionButtons}
                    onClick={$ev => {
                      $ev.stopPropagation();
                      generateBlankContract({ variables: { id } });
                    }}
                  >
                    <CloudDownloadIcon className={classes.optionIcon} />
                  </IconButton>
                </Tooltip>
              </>
            }
          />
        );
      },
      customHeadRender: columnMeta => {
        return (
          <TableCell
            id={columnMeta.index}
            key={columnMeta.index}
            style={{ borderBottom: 'none' }}
          >
            <Typography
              variant="subtitle1"
              align="left"
              className={classes.tableTitle}
            >
              {columnMeta.label}
            </Typography>
          </TableCell>
        );
      },
    }),
  ];

  const [getReport] = useLazyQuery(GET_REPORT_EXCEL, {
    fetchPolicy: 'no-cache',
    enqueueSnackbar,
    onError: error => errorMessage(error, enqueueSnackbar),
    onCompleted: pdfResponse => {
      if (pdfResponse.contractsExcel) {
        if (!pdfResponse.contractsExcel.file)
          errorMessage('Error, intente de nuevo.', enqueueSnackbar);
        if (pdfResponse.contractsExcel.file) {
          downloadBase64Document(
            pdfResponse.contractsExcel.file,
            'contratos.xlsx',
            'xlsx',
          );
          successMessage('Éxito, descarga completada.', enqueueSnackbar);
        }
      } else errorMessage('Error, intente de nuevo.', enqueueSnackbar);
    },
  });

  const handleReport = () => {
    getReport({
      variables: {
        search: searchText || null,
        fundId: filterFund || null,
        promoterId: filterPromoter || null,
        state: filterState || null,
        fromDate: appliedFromDate || null,
        toDate: appliedToDate || null,
      },
    });
  };

  const options = {
    filterType: 'dropdown',
    responsive: 'standard',
    searchOpen: true,
    selectableRows: 'none',
    print: false,
    filter: false,
    download: false,
    pagination: false,
    textLabels,
    customToolbar: () => {
      return (
        <>
          <Tooltip title="Descargar reporte">
            <IconButton color="secondary" onClick={handleReport}>
              <AssignmentReturnedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Refrescar">
            <IconButton
              color="secondary"
              onClick={e => {
                setPageLength(10);
                setSearchText('');
                setSearchTextInput('');
                setFilterPromoter('');
                refetchList({
                  search: '',
                  promoterId: '',
                  first: 10,
                  afterCursor: null,
                  last: null,
                  beforeCursor: null,
                });
              }}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </>
      );
    },
    customSearchRender: () => {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            flexWrap: 'nowrap',
            width: '100%',
          }}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              handleSearchSubmit(e);
            }
          }}
        >
          <Input
            autoFocus
            className={classes.searchInput}
            variant="outlined"
            type="text"
            value={searchTextInput}
            onChange={e => setSearchTextInput(e.target.value)}
            style={{ flex: 1, minWidth: 220 }}
          />
          <Button
            type="button"
            variant="contained"
            className={classes.searchButton}
            onClick={handleSearchSubmit}
            style={{ whiteSpace: 'nowrap', marginLeft: 0 }}
          >
            Buscar (DNI o Nombres)
          </Button>
          <Button
            type="button"
            variant="contained"
            color="primary"
            size="small"
            onClick={handleSearchClear}
            style={{
              minWidth: 'auto',
              padding: '4px 10px',
              lineHeight: 1.2,
              whiteSpace: 'nowrap',
            }}
          >
            X
          </Button>
        </div>
      );
    },
    onSearchClose: () => {
      setPageLength(10);
      setSearchText('');
      setSearchTextInput('');
      setAppliedFromDate(null);
      setAppliedToDate(null);
      setFilterFund('');
      setFilterPromoter('');
      setFilterState('');
      refetchList({
        search: '',
        fundId: '',
        promoterId: '',
        state: '',
        fromDate: null,
        toDate: null,
        first: 10,
        afterCursor: null,
        last: null,
        beforeCursor: null,
      });
    },
  };

  return (
    <>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20 }}>
        <div style={{ display: 'flex', gap: 20, marginBottom: 20 }}>
          <FormControl variant="outlined" style={{ minWidth: 400 }}>
            <InputLabel>Fondo</InputLabel>
            <Select
              value={filterFund}
              onChange={e => {
                setFilterFund(e.target.value);
              }}
              label="Fondo"
            >
              <MenuItem value="">
                <em>Todos</em>
              </MenuItem>
              {edgeToList(fundsData, 'listFunds')
                .filter(t => allowedFundsIds.includes(t.id))
                .map(t => (
                  <MenuItem key={t.id} value={t.id}>
                    {t.businessName}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
          <FormControl variant="outlined" style={{ minWidth: 400 }}>
            <InputLabel>Promotor/Asesor</InputLabel>
            <Select
              value={filterPromoter}
              onChange={e => {
                setFilterPromoter(e.target.value);
              }}
              label="Promotor/Asesor"
            >
              <MenuItem value="">
                <em>Todos</em>
              </MenuItem>
              {edgeToList(promotersData, 'listPromoter').map(t => (
                <MenuItem key={t.id} value={t.id}>
                  {t.firstName} {t.lastName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>
        <div style={{ display: 'flex', gap: 20, marginBottom: 20 }}>
          <FormControl variant="outlined" style={{ minWidth: 400 }}>
            <InputLabel>Estado</InputLabel>
            <Select
              value={filterState}
              onChange={e => setFilterState(e.target.value)}
              label="Estado"
            >
              <MenuItem value="">
                <em>Todos</em>
              </MenuItem>

              <MenuItem value={CONTRACT_STATE_KEYS.GENERATED}>
                Generado (Enviado a firma)
              </MenuItem>
              <MenuItem value={CONTRACT_STATE_KEYS.EDIT_PENDING}>
                Pendiente de Aprobar y Enviar
              </MenuItem>
              <MenuItem value={CONTRACT_STATE_KEYS.APPROVED}>
                Aprobado/Enviado
              </MenuItem>
              <MenuItem value={CONTRACT_STATE_KEYS.SIGNED}>Firmado</MenuItem>
              <MenuItem value={CONTRACT_STATE_KEYS.UPLOADED}>Subido</MenuItem>
              <MenuItem value={CONTRACT_STATE_KEYS.PENDING}>
                Pendiente de Editar/Generar
              </MenuItem>
            </Select>
          </FormControl>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <div style={{ display: 'flex', gap: 12 }}>
              <DatePicker
                style={{ width: 200 }}
                autoOk
                label="Desde"
                value={fromDate}
                onChange={setFromDate}
                inputVariant="outlined"
                format="YYYY-MM-DD"
                clearable
                maxDate={toDate}
                maxDateMessage={null}
                invalidDateMessage={null}
              />

              <DatePicker
                style={{ width: 200 }}
                autoOk
                label="Hasta"
                value={toDate}
                onChange={setToDate}
                inputVariant="outlined"
                format="YYYY-MM-DD"
                clearable
                minDate={fromDate}
                minDateMessage={null}
                invalidDateMessage={null}
              />
            </div>
          </MuiPickersUtilsProvider>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => {
              setAppliedFromDate(
                fromDate ? fromDate.format('YYYY-MM-DD') : null,
              );
              setAppliedToDate(toDate ? toDate.format('YYYY-MM-DD') : null);
            }}
          >
            Aplicar Fechas
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setSearchText('');
              setSearchTextInput('');
              setFromDate(moment('2026-01-01'));
              setToDate(moment());
              setAppliedFromDate(null);
              setAppliedToDate(null);
              setFilterFund('');
              setFilterPromoter('');
              setFilterState('');
              setPageLength(10);
              refetchList({
                search: '',
                fundId: '',
                promoterId: '',
                state: '',
                fromDate: null,
                toDate: null,
                first: 10,
                afterCursor: null,
                last: null,
                beforeCursor: null,
              });
            }}
          >
            Limpiar
          </Button>
        </div>
      </div>
      <div className={classes.tableContainer}>
        {listLoading ||
        loadingGenerateBlankContract ||
        updateLoading ||
        loadingEditContract ||
        loadingApproveContract ||
        loadingGenerateContract ||
        loadingUploadContract ? (
          <LoadingIndicator />
        ) : (
          <>
            <MUIDataTable
              title="Contratos"
              data={participationList}
              columns={columns}
              options={options}
            />
            <div className={classes.buttonContainer}>
              {listLength < pageLength && pageLength > totalCount ? (
                <div className={classes.paginationText}>
                  {totalCount} de {totalCount}
                </div>
              ) : (
                <div className={classes.paginationText}>
                  {pageLength} de {totalCount}
                </div>
              )}
              {pageLength - listLength > 0 && listLength != totalCount ? (
                <div
                  className={classes.paginationButton}
                  onClick={() => {
                    if (pageLength > totalCount) setPageLength(pageLength - 10);
                    else setPageLength(pageLength - listLength);
                    if (pageInfo?.startCursor) {
                      fetchMore({
                        variables: {
                          beforeCursor: pageInfo.startCursor,
                          last: 10,
                          afterCursor: null,
                          first: null,
                        },
                        updateQuery: (prev, { fetchMoreResult }) => {
                          if (!fetchMoreResult) return prev;
                          return fetchMoreResult;
                        },
                      });
                    }
                  }}
                >
                  {' '}
                  Anterior{' '}
                </div>
              ) : (
                <span></span>
              )}
              {pageLength < totalCount ? (
                <div
                  className={classes.paginationButton}
                  onClick={() => {
                    setPageLength(pageLength + listLength);
                    fetchMore({
                      variables: {
                        afterCursor: pageInfo?.endCursor,
                        first: 10,
                        last: null,
                        beforeCursor: null,
                      },
                      updateQuery: (prev, { fetchMoreResult }) => {
                        if (!fetchMoreResult) return prev;
                        return fetchMoreResult;
                      },
                    });
                  }}
                >
                  {' '}
                  Siguiente{' '}
                </div>
              ) : (
                <span></span>
              )}
            </div>

            <PDFViewerModal
              showModal={showModal}
              onClosePress={() => setShowModal(false)}
              fileURL={url}
              loading={false}
            />

            <Snackbar
              open={openSnackbar}
              autoHideDuration={3000}
              onClose={() => setOpenSnackbar(false)}
              message="Debe marcar al menos una opción"
            />

            <Snackbar
              open={openSpouseSnackbar}
              autoHideDuration={3000}
              onClose={() => setOpenSpouseSnackbar(false)}
              message={
                invalidEmail
                  ? 'Correo Inválido'
                  : 'Debe llenar el correo de su cónyuge'
              }
            />

            {openUploadModal ? (
              <CustomModal
                fullWidth
                maxWidth="md"
                showModal={openUploadModal}
                title={`CARGAR CONTRATO`}
                onClosePress={() => {
                  setOpenUploadModal(false);
                }}
              >
                <div className={classes.modalContent}>
                  <Grid item xs={6} className={classes.datePickers}>
                    <DatePicker
                      autoOk
                      fullWidth
                      required
                      value={uploadedDate}
                      format="YYYY-MM-DD"
                      label="Fecha de Firma"
                      emptyLabel="Ingrese una fecha de firma"
                      inputVariant="outlined"
                      color="secondary"
                      onChange={date => {
                        setUploadedDate(date.format(dateFormat));
                      }}
                      error={false}
                      helperText=""
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <TodayIcon color="secondary" />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <br></br>
                  <br></br>
                  <Grid className={classes.labelContainer} item xs={6}>
                    {fileName && (
                      <div>
                        <small>{fileName}</small>
                      </div>
                    )}
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      fullWidth
                      variant="contained"
                      component="label"
                      color="secondary"
                      name="file"
                      required
                    >
                      Buscar Contrato (solo PDF)
                      <input
                        id="file"
                        name="file"
                        type="file"
                        style={{ display: 'none' }}
                        onChange={e => handleChange(e)}
                      />
                    </Button>
                  </Grid>
                </div>
                <div className={classes.modalFooter}>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={fileName === '' || !uploadedDate}
                    onClick={() => {
                      uploadContract({
                        variables: {
                          id: clientID,
                          file: file,
                          uploadedDate: uploadedDate,
                        },
                      });
                      setOpenUploadModal(false);
                      setFileName('');
                      setFile('');
                    }}
                  >
                    Guardar
                  </Button>
                </div>
              </CustomModal>
            ) : null}

            {openContractModal ? (
              <CustomModal
                fullWidth
                maxWidth="lg"
                showModal={openContractModal}
                title={`ANEXO 2: DECLARACIÓN JURADA DE LICITUD DE ORIGEN Y DESTINO DE LOS FONDOS`}
                onClosePress={() => {
                  setOpenContractModal(false);
                }}
              >
                <div className={classes.modalContent}>
                  <p>
                    {' '}
                    Yo, {currentName}, con DNI N.° {documentNumber}, con
                    domicilio en {detail}, distrito de {distrito}, provincia de{' '}
                    {provincia} y departamento de {departamento}, país {pais},
                    en adelante “CLIENTE”, de conformidad con lo dispuesto en la
                    Resolución SBS N.º 2660-2015, Reglamento de Gestión de
                    Riesgo de Lavado de Activos y del Financiamiento del
                    Terrorismo, así como la Resolución CONASEV N°
                    033-2011-EF-94.01.1, Normas para la Prevención del Lavado de
                    Activos y Financiamiento del Terrorismo y sus normas
                    modificatorias, en carácter de Declaración Jurada manifiesto
                    que los fondos provienen de actividades licitas, tanto en
                    origen como en destino, según se declaran a continuación (de
                    ser necesario, puede marcar más de una alternativa):
                  </p>
                  <Grid item xs={12}>
                    <Checkbox
                      checked={remuneraciones}
                      onChange={e => setRemuneraciones(e.target.checked)}
                    />
                    Remuneraciones
                    <br></br>
                    <Checkbox
                      checked={ahorro}
                      onChange={e => setAhorro(e.target.checked)}
                    />
                    Ahorro en Entidades Financieras
                    <br></br>
                    <Checkbox
                      checked={utilidades}
                      onChange={e => setUtilidades(e.target.checked)}
                    />
                    Utilidades/dividendos
                    <br></br>
                    <Checkbox
                      checked={alquileres}
                      onChange={e => setAlquileres(e.target.checked)}
                    />
                    Alquileres de inmuebles
                    <br></br>
                    <Checkbox
                      checked={ventaAcciones}
                      onChange={e => setVentaAcciones(e.target.checked)}
                    />
                    Venta de Acciones
                    <br></br>
                    <Checkbox
                      checked={ventaBienesInmuebles}
                      onChange={e => setVentaBienesInmuebles(e.target.checked)}
                    />
                    Venta de Bienes Inmuebles
                    <br></br>
                    <Checkbox
                      checked={ventaBienesMuebles}
                      onChange={e => setVentaBienesMuebles(e.target.checked)}
                    />
                    Venta de Bienes Muebles
                    <br></br>
                    <Checkbox
                      checked={herencias}
                      onChange={e => setHerencias(e.target.checked)}
                    />
                    Herencias
                    <br></br>
                    <Checkbox
                      checked={prestamos}
                      onChange={e => setPrestamos(e.target.checked)}
                    />
                    Préstamos
                    <br></br>
                    <Checkbox
                      checked={otros}
                      onChange={e => setOtros(e.target.checked)}
                    />
                    Otros
                    <br></br>
                    <br></br>
                    <TextField
                      name="otrosTexto"
                      label="Especificar (Otros)"
                      variant="outlined"
                      disabled={!otros}
                      fullWidth
                      onChange={e => setOtrosTexto(e.target.value)}
                    />
                    <br></br>
                    <br></br>
                    <TextField
                      name="explicacion"
                      label="Breve explicación de la(s) fuente(s)"
                      variant="outlined"
                      fullWidth
                      multiline
                      onChange={e => setExplicacion(e.target.value)}
                    />
                  </Grid>
                  <br></br>
                  <p>
                    Debido a lo anteriormente manifestado, autorizo a Core
                    Capital Sociedad Administradora de Fondos de Inversiones
                    S.A., a verificar por medios propios o contratados,
                    utilizando la información disponible en páginas Web e
                    Intranet, la información aquí suministrada y exonero a dicha
                    empresa de las responsabilidades a que hubiere lugar en caso
                    de comprobarse la procedencia Ilícita de capitales o datos
                    falsos, y así dar cumplimiento a lo establecido en las
                    Normas Legales.
                  </p>
                  <br></br>
                  <Checkbox
                    checked={autorizo}
                    onChange={e => setAutorizo(e.target.checked)}
                  />
                  Autorizo el tratamiento de mis datos para el cumplimiento de
                  finalidades adicionales.
                  <br></br>
                  <br></br>
                  {isMarried ? (
                    <>
                      <br></br>
                      <span style={{ fontWeight: '600' }}>
                        Necesita la firma de su cónyuge en el contrato?
                      </span>
                      <br></br>
                      <Checkbox
                        checked={spouse}
                        onChange={e => setSpouse(e.target.checked)}
                      />
                      Si (por favor llenar el correo de su cónyuge)
                      <br></br>
                      <TextField
                        name="spouseEmail"
                        label="Correo cónyuge"
                        variant="outlined"
                        type="email"
                        disabled={!spouse}
                        fullWidth
                        onChange={e => setSpouseEmail(e.target.value)}
                      />
                    </>
                  ) : null}
                </div>
                <div className={classes.modalFooter}>
                  <Button
                    variant="contained"
                    color="secondary"
                    disabled={false}
                    onClick={() => {
                      setOpenContractModal(false);
                    }}
                  >
                    Cancelar
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={false}
                    onClick={() => {
                      if (!atLeastOneChecked()) {
                        setOpenSnackbar(true);
                        return;
                      }
                      const tmp = {
                        remuneraciones: remuneraciones,
                        ahorro: ahorro,
                        utilidades: utilidades,
                        alquileres: alquileres,
                        ventaAcciones: ventaAcciones,
                        ventaBienesInmuebles: ventaBienesInmuebles,
                        ventaBienesMuebles: ventaBienesMuebles,
                        herencias: herencias,
                        prestamos: prestamos,
                        otros: otros,
                        otrosTexto: otrosTexto,
                        explicacion: explicacion,
                        email: spouseEmail,
                        spouseSign: spouse,
                      };
                      if (spouse && spouseEmail == '') {
                        setOpenSpouseSnackbar(true);
                        return;
                      }
                      if (
                        spouse &&
                        spouseEmail &&
                        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(spouseEmail)
                      ) {
                        setInvalidEmail(true);
                        setOpenSpouseSnackbar(true);
                        return;
                      }
                      setCampos(tmp);
                      editContract({
                        variables: {
                          id: participationID,
                          autorizo: autorizo,
                          spouseSign: spouse,
                        },
                      });
                      setOpenContractModal(false);
                      setOtrosTexto('');
                      setExplicacion('');
                    }}
                  >
                    Guardar
                  </Button>
                </div>
              </CustomModal>
            ) : null}
          </>
        )}
      </div>
    </>
  );
}

RaisingsParticipants.propTypes = {
  raisingID: PropTypes.string,
};

export default RaisingsParticipants;
